import { render, staticRenderFns } from "./ClientStakeHolderCollector.vue?vue&type=template&id=31c7d742"
import script from "./ClientStakeHolderCollector.vue?vue&type=script&lang=js"
export * from "./ClientStakeHolderCollector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports